import * as React from 'react';
import { withRouter } from 'react-router-dom';
import Head from '../Head';
class Status extends React.Component {
    render() {
        const { code, history: { location: { pathname } }, children, staticContext } = this.props;
        if (staticContext)
            staticContext.statusCode = code;
        return (React.createElement(React.Fragment, null,
            pathname && code >= 400 && code < 600 && (React.createElement(Head, { data: {
                    head: {
                        title: `Error ${code}`
                    },
                    __typename: 'Error'
                } })),
            children));
    }
}
export default withRouter(Status);
//# sourceMappingURL=Status.js.map